module.exports = __webpack_public_path__ + "static/media/activity_card.1cbd4522.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/activity_card.png
// module id = 510
// module chunks = 0